$(document).ready(function(){
	
	$('.goToRegistrationForm').on('click', function(e){
		e.preventDefault();

		// -- Vars --
		var files;
		var href = $(this).attr('href');
		var csrf = $(this).attr('data-csrf');
		var id = $(this).attr('id');
		var data = {
			'CRAFT_CSRF_TOKEN': csrf,
			'id': id,
		};

		// -- Ajax request to load registration form --
		$.ajax({
		  type: 'POST',
		  url: href,
		  data: data,
	    cache: false,
		  dataType: 'html',
		  success: function(response, statut){
		    console.log('success : load registration form');
		    // -- Get response --
		    $('.registration__wrapper').html(response);
		    // -- Scroll to form --
		    var scrollTop = $('.main__container').scrollTop();
		    var registrationPos = $('.registration__wrapper').offset().top;
				$('.main__container').animate({
					scrollTop: registrationPos + scrollTop - 20
				},'slow');
				// -- Reinit plugins --
				reinitPlugins();
				// -- Listen to submit event --
				prepareUpload();
				formBuilderSubmission(); // ajax
		  },
		  error: function(response, statut, error){
		    console.log('Ajax bad request');
		    console.log(response);
		    location.reload();
		  }
		});

	});


	// -- Functions --
	function formBuilderSubmission(){

		var form = $('.ajax__form');

		form.on('submit', function(e) {

	    // -- Config --
		  e.preventDefault();
	    
	    // -- Variables --
	    var url = window.location.href;
	    var data = $(this).serialize();
	    data[csrfTokenName] = csrfTokenValue;
	    var nationalId = $(this).find('#studentNationalId').val();

	    // -- Reset notifications --
	    $('.form__notifications .error, .form__notifications .success').fadeOut();
			$('.form-group.field').removeClass('error').find('.errors').html('').fadeOut();
			$('.picker__errors').fadeOut();

	    // -- Ajax request to save entry and send email of form data --
	    $.ajax({
	      type: 'POST',
	      url: url,
	      data: data,
	      dataType: 'json',
		    beforeSend: function(jqXHR, settings) { 

		      // Disable submit button
		      form.find('input[type="submit"]').prop('disabled', true);
		      // -- Validate national id  && Validate datepicker --
		      var checkNationalId = validateNationalId(nationalId);
		      var checkDatePicker = validateDatePicker();
		      if (checkNationalId == true && checkDatePicker == true) {
		        // -- Upload file(s) (ajax request) --
		        uploadFilesResponse = uploadFiles(nationalId);
		        // -- Add files paths to data --
		        if (typeof files == 'undefined' || files.length == 0) {
							settings.data += "&certificatesPaths=";
		        } else if (typeof files !== 'undefined') {
							settings.data += "&certificatesPaths=" + encodeURIComponent(uploadFilesResponse.certificatesPaths);
						}
		      } else {
		        // -- Display notifications --
			      $('.form__notifications .error').fadeIn();

				    // -- Scroll to form --
						$('.main__container').animate({
					  	scrollTop: $('.registration__wrapper').position().top
						},'slow');

		        // -- Enable submit button --
			      form.find('input[type="submit"]').prop('disabled', false);
		      	// -- Stop ajax save entry and send email --
	        	return false;
		      }

		    },
	      success: function(response, statut){
	      	// console.log(response);
	        // -- Enable submit button --
		      form.find('input[type="submit"]').prop('disabled', false);

	        // -- Scroll for feedback --
					$('.main__container').animate({
					  scrollTop: $('.registration__wrapper').position().top
					},'slow');

					// -- Feedback --
					if (!response.success) { // ERROR
		        console.log('error : form validation - save entry and send email');
		        // -- Display notifications --
			      $('.form__notifications .error').fadeIn();

						$.each(response.validationErrors, function(key, value) {
			      	// -- Display errors --
							$('.field--'+key).addClass('error').find('.errors').html('<p>' + value + '</p>').fadeIn();
							
							// -- Update errors --
							$('.field--'+key+' input, .field--'+key+' textarea, .field--'+key+' select').on('change',function(){
								$('.field--'+key).removeClass('error').find('.errors').fadeOut();
							});
						});

						// -- Delete file(s) uploaded --
						if (typeof files !== 'undefined') {
							deleteFiles(uploadFilesResponse);
						}

		      } else { // SUCCESS
		      	console.log('success : form validation - save entry and send email');
		      	// -- Hide form --
		        form.delay(400).fadeOut();
		        // -- Display notifications --
			      $('.form__notifications .success').delay(800).fadeIn();
		      }

	      },
	      error: function(response, statut, error){
	        console.log('Ajax bad request');
	        console.log(response);
	        location.reload();
	      },
	      // complete: function(jqXHR){
	      // 	var response = jqXHR.responseJSON.submissionData;
	      // 	if (typeof response !== 'undefined' && response.newsletter == 'yes') {
			  // // -- Plugin not working on craft 2 anymore --deprecied
	      // 		mailchimpSubscribe();
	      // 	}
	      // }
	    });
	       
		});

	}

	function termsAndConditions(input){
		var checked = input.checked ? true : false;
		if (!checked) {
			$('.field--termsAndConditions').addClass('error').find('.errors').fadeIn();
		} else {
			$('.field--termsAndConditions').removeClass('error').find('.errors').fadeOut();
		}
	}


	function reinitPlugins(){
		$('select').niceSelect();
		$('.datepicker').pickadate();
	}


	function prepareUpload(){
		$('.type--file input').each(function(){
			var $input = $(this);
			var $label = $input.next('label');
			var labelVal = $label.html();

			$label.find('.btn--reset').on('click', function(e){
				e.preventDefault();
				$input.val('');
				$label.find('span').html('');
			});

			$input.on('change', function(e){
				var fileName = '';
				if(this.files && this.files.length > 1) {
					fileName = (this.getAttribute('data-multiple-caption') || '' ).replace( '{count}', this.files.length);
				} else if(e.target.value) {
					fileName = e.target.value.split('\\').pop();
				}

				if(fileName) {
					$label.find('span').html(fileName);
				} else {
					$label.html(labelVal);
				}

				files = e.target.files;
			});

			// -- Firefox bug fix --
			$input.on('focus', function(){
				$input.addClass('has-focus'); 
			}).on('blur', function(){
				$input.removeClass('has-focus');
			});

		});
	}


	function validateDatePicker(){
		var studentBirthdate = $('input[name="studentBirthdate"]');
		if (studentBirthdate.val() == '') {
			studentBirthdate.parents('.input__wrapper').find('.picker__errors').fadeIn();
			return false;
		} else {
			return true;
		}
	}

	function validateNationalId(nationalId){
		if (nationalId !== '') {
			var regex = /^(\d{13})?$/;
			var regexResult = regex.test(nationalId);
			if (regexResult == true) {
				return true;
			} else {
				$('.field--studentNationalId').addClass('error').find('.errors').html('<p>Format: YYYYMMDDXXXC1C2 (13 digits without spaces)</p>').fadeIn();
				return false;
			}			
		} else {
			$('.field--studentNationalId').addClass('error').find('.errors').html('<p>Student National Id cannot be blank.</p>').fadeIn();
			return false;			
		}
	}

	function uploadFiles(nationalId){
    // -- Create a formdata object and add the files --
    var uploadFilesResponse = {};
    var data = new FormData();
    data.append(csrfTokenName, csrfTokenValue);
    data.append('nationalId', nationalId);

    if (typeof files !== 'undefined') {
    	$.each(files, function(key, value){
    		data.append(key, value);
    	});
	    // -- Ajax request to save file(s) of form data --
	    $.ajax({
	    	type: 'POST',
	    	url: 'actions/filesUpload/saveFiles',
	    	dataType: 'json',
	    	data: data,
	    	async: false,
	    	cache: false,
	      processData: false, // Don't process the files
	      // contentType: 'multipart/form-data',
	      contentType: false, // Set content type to false as jQuery will tell the server its a query string request
	      success: function(response, textStatus, jqXHR){
	      	if (response.status == 'success') {
	      		console.log('success : save file(s) on server');
	      		uploadFilesResponse = response;
	      		return uploadFilesResponse;
	      	} else {
	      		console.log('error : save file(s) on server');
	      	}
	      },
	      error: function(jqXHR, textStatus, errorThrown){
	      	console.log('Ajax bad request : save file(s) on server');
	      	console.log(jqXHR);
	      	console.log(data);
	      }
	    });
    }
    return uploadFilesResponse;
  }


  function deleteFiles(uploadFilesResponse){
		// -- Ajax request to delate file(s) of form data --
		var data = uploadFilesResponse;
    data[csrfTokenName] = csrfTokenValue;

		$.ajax({
			type: 'POST',
			url: 'actions/filesUpload/deleteFiles',
			dataType: 'json',
			data: data,
		  success: function(response, textStatus, jqXHR){
		  	if (response.status == 'success') {
		  		console.log('success : delete file(s) on server');
		  		console.log(response);

		  	} else {
		  		console.log('error : delete file(s) on server');
		  	}
		  },
		  error: function(jqXHR, textStatus, errorThrown){
		  	console.log('Ajax bad request');
		  	console.log(jqXHR);
		  }
		});
  }

  // // -- Plugin not working on craft 2 anymore --deprecied
  // function mailchimpSubscribe(){
		// var data = {
		// 	'CRAFT_CSRF_TOKEN': csrfTokenValue,
		// 	'mcvars[FULLNAME]': $('input[name="guardianFullName"]').val(),
		// 	'mcvars[PHONE]': $('input[name="guardianPhone"]').val(),
		// 	'email': $('input[name="guardianEmail"]').val(),
		// 	'lid': $('input[name="lid"]').val(),
		// };
  //   $.post('actions/mailchimpSubscribe/list/subscribe', data, function(data, jqXHR) {
  //   	console.log(data);
  //     if (!data.success){
  //       // there was an error, do something with data
  //       console.log('error : newsletter registration');
  //       $('.mcSubscribe__notifications').find('.error').fadeIn();
  //     } else {
  //       // Success
  //       console.log('success : newsletter registration');
  //       $('.mcSubscribe__notifications').find('.success').fadeIn();
  //     }
		// });
  // }

});
